import { createContext, useContext, useState } from 'react';

const dict = {
  it: {
    'nav.browse': 'Sfoglia',
    'nav.enroll': 'Iscriviti',
    'nav.venues': 'Le Sedi',
    'nav.contacts': 'Contatti',
    'hero.overline': 'Amici per la Musica APS · Rovigo — Polesella',
    'hero.subtitle':
      "Anno Accademico 2026–2027. Sei masterclass di alto perfezionamento con i grandi maestri dell'Arena di Verona, del Teatro dell'Opera di Roma e della Finnish Radio Symphony.",
    'hero.cta1': 'Sfoglia la brochure',
    'hero.cta2': 'Le sedi',
    'hero.scroll': 'Scorri alla brochure',
    'book.overline': 'La brochure digitale',
    'book.title.a': 'Sfogliala come una',
    'book.title.b': 'rivista vera',
    'book.desc':
      "Trascina l'angolo della pagina o usa le frecce. Clicca la lente per leggere ogni dettaglio da vicino.",
    'controls.page': 'Pagina',
    'controls.prev': 'Pagina precedente',
    'controls.next': 'Pagina successiva',
    'controls.zoom': 'Ingrandisci',
    'controls.fullscreen': 'Schermo intero',
    'controls.reduce': 'Riduci',
    'controls.soundOn': 'Disattiva suono di sfoglio',
    'controls.soundOff': 'Attiva suono di sfoglio',
    'share.title': 'Condividi',
    'share.native': 'Altri social…',
    'share.copy': 'Copia link',
    'share.copied': 'Link copiato negli appunti',
    'share.copyError': 'Impossibile copiare il link',
    'share.ebook': 'Scarica ebook (EPUB)',
    'share.ebookBusy': 'Creazione ebook…',
    'share.ebookDone': 'Ebook della brochure scaricato (EPUB)',
    'share.ebookError': "Errore durante la creazione dell'ebook",
    'zoom.hint': 'Rotellina o slider per ingrandire · trascina per spostarti',
    'info.overline': '02 — Dove e quando',
    'info.title.a': 'Le sedi delle',
    'info.dates': 'Novembre 2026 — Giugno 2027',
    'info.dates.l1': '6 masterclass, posti limitati',
    'info.dates.l2': 'Iscrizioni aperte',
    'cta.title.a': 'Iscriviti ora per',
    'cta.title.b': 'assicurarti il posto',
    'cta.sub': 'Posti limitati — minimo 4 allievi per masterclass.',
    'cta.button': 'Scrivici ora',
    'form.overline': '03 — Iscrizioni',
    'form.title.a': 'Iscriviti',
    'form.title.b': 'online',
    'form.desc':
      'Compila il modulo: ti ricontatteremo per confermare il tuo posto e indicarti le modalità di pagamento della quota.',
    'form.name': 'Nome e cognome',
    'form.email': 'Email',
    'form.phone': 'Telefono',
    'form.course': 'Masterclass',
    'form.role': 'Partecipo come',
    'form.role.student': 'Allievo effettivo',
    'form.role.auditor': 'Uditore',
    'form.message': 'Messaggio (facoltativo)',
    'form.privacy':
      "Acconsento al trattamento dei dati personali ai sensi del GDPR per la gestione dell'iscrizione.",
    'form.submit': 'Invia iscrizione',
    'form.sending': 'Invio in corso…',
    'form.success': 'Iscrizione inviata! Ti contatteremo presto.',
    'form.error': "Errore nell'invio. Riprova o scrivici via email.",
    'form.required': 'Compila i campi obbligatori e accetta la privacy.',
    'footer.contacts': 'Contatti',
    'footer.follow': 'Seguici',
    'footer.tagline':
      'Scuola di Musica e Spettacolo · Centro registrato Trinity College London',
    'footer.rights': '© 2026 Amici per la Musica APS — Tutti i diritti riservati',
  },
  en: {
    'nav.browse': 'Browse',
    'nav.enroll': 'Enrol',
    'nav.venues': 'Venues',
    'nav.contacts': 'Contacts',
    'hero.overline': 'Amici per la Musica APS · Rovigo — Polesella',
    'hero.subtitle':
      'Academic Year 2026–2027. Six advanced masterclasses led by renowned maestros from the Arena di Verona, the Teatro dell\u2019Opera di Roma and the Finnish Radio Symphony Orchestra.',
    'hero.cta1': 'Browse the brochure',
    'hero.cta2': 'Venues',
    'hero.scroll': 'Scroll to the brochure',
    'book.overline': 'The digital brochure',
    'book.title.a': 'Browse it like a',
    'book.title.b': 'real magazine',
    'book.desc':
      'Drag the page corner or use the arrows. Click the lens to read every detail up close.',
    'controls.page': 'Page',
    'controls.prev': 'Previous page',
    'controls.next': 'Next page',
    'controls.zoom': 'Zoom in',
    'controls.fullscreen': 'Fullscreen',
    'controls.reduce': 'Reduce',
    'controls.soundOn': 'Mute page-turn sound',
    'controls.soundOff': 'Enable page-turn sound',
    'share.title': 'Share',
    'share.native': 'More social…',
    'share.copy': 'Copy link',
    'share.copied': 'Link copied to clipboard',
    'share.copyError': 'Unable to copy the link',
    'share.ebook': 'Download ebook (EPUB)',
    'share.ebookBusy': 'Building ebook…',
    'share.ebookDone': 'Brochure ebook downloaded (EPUB)',
    'share.ebookError': 'Error while creating the ebook',
    'zoom.hint': 'Wheel or slider to zoom · drag to pan',
    'info.overline': '02 — Where & when',
    'info.title.a': 'Masterclass',
    'info.dates': 'November 2026 — June 2027',
    'info.dates.l1': '6 masterclasses, limited places',
    'info.dates.l2': 'Enrolment open',
    'cta.title.a': 'Enrol now to',
    'cta.title.b': 'secure your place',
    'cta.sub': 'Limited places — minimum 4 students per masterclass.',
    'cta.button': 'Write to us',
    'form.overline': '03 — Enrolment',
    'form.title.a': 'Enrol',
    'form.title.b': 'online',
    'form.desc':
      'Fill in the form: we will contact you to confirm your place and give you the fee payment details.',
    'form.name': 'Full name',
    'form.email': 'Email',
    'form.phone': 'Phone',
    'form.course': 'Masterclass',
    'form.role': 'I enrol as',
    'form.role.student': 'Active student',
    'form.role.auditor': 'Auditor',
    'form.message': 'Message (optional)',
    'form.privacy':
      'I consent to the processing of my personal data under GDPR for enrolment purposes.',
    'form.submit': 'Send enrolment',
    'form.sending': 'Sending…',
    'form.success': 'Enrolment sent! We will contact you soon.',
    'form.error': 'Sending failed. Please try again or email us.',
    'form.required': 'Please fill in the required fields and accept the privacy policy.',
    'footer.contacts': 'Contacts',
    'footer.follow': 'Follow us',
    'footer.tagline':
      'Music and Performing Arts School · Registered Trinity College London Centre',
    'footer.rights': '© 2026 Amici per la Musica APS — All rights reserved',
  },
};

const LangCtx = createContext({ lang: 'it', t: (k) => k, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem('tm-lang') || 'it'
  );
  const setLang = (l) => {
    localStorage.setItem('tm-lang', l);
    setLangState(l);
  };
  const t = (key) => dict[lang][key] ?? dict.it[key] ?? key;
  return (
    <LangCtx.Provider value={{ lang, t, setLang }}>{children}</LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
